'use client';

import { c as _c } from "react/compiler-runtime";
import { useDraftModeEnvironment, useIsPresentationTool } from 'next-sanity/hooks';
import { useRouter } from 'next/navigation';
import { useEffect, useTransition } from 'react';
import { toast } from 'sonner';
import { disableDraftMode } from './server-functions';
export function DraftModeToast() {
  const $ = _c(8);
  const isPresentationTool = useIsPresentationTool();
  const env = useDraftModeEnvironment();
  const router = useRouter();
  const [pending, startTransition] = useTransition();
  let t0;
  let t1;
  if ($[0] !== env || $[1] !== isPresentationTool || $[2] !== router) {
    t0 = () => {
      if (isPresentationTool === false) {
        const toastId = toast("Draft Mode Enabled", {
          id: "draft-mode-toast",
          description: env === "live" ? "Content is live, refreshing automatically" : "Refresh manually to see changes",
          duration: Infinity,
          action: {
            label: "Disable",
            onClick: () => startTransition(async () => {
              await disableDraftMode();
              startTransition(() => router.refresh());
            })
          }
        });
        return () => {
          toast.dismiss(toastId);
        };
      }
    };
    t1 = [env, router, isPresentationTool];
    $[0] = env;
    $[1] = isPresentationTool;
    $[2] = router;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[5] !== pending) {
    t2 = () => {
      if (pending) {
        const toastId_0 = toast.loading("Disabling draft mode...");
        return () => {
          toast.dismiss(toastId_0);
        };
      }
    };
    t3 = [pending];
    $[5] = pending;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
}